/**
 * Start Meeting Types
 *
 * Story 4.3: Communications Hub Enhancement
 *
 * Types for starting ad-hoc meetings and scheduling meetings
 * with Google Meet / Microsoft Teams integration.
 */
import { z } from 'zod';
import { MeetingPlatform } from './meeting-toast.js';
export const StartMeetingPlatformSchema = z.enum(Object.values(MeetingPlatform)).nullable();
export const StartMeetingRequestSchema = z.object({
    platform: StartMeetingPlatformSchema,
    title: z.string().min(1).max(200),
    clientId: z.string().uuid().optional(),
    dealId: z.string().uuid().optional(),
    attendeeEmails: z.array(z.string().email()).max(50).optional(),
    externalMeeting: z.boolean().optional().default(false),
});
export const StartMeetingResponseSchema = z.object({
    meetingId: z.string().uuid(),
    title: z.string(),
    meetingLink: z.string().url().nullable(),
    platform: StartMeetingPlatformSchema,
    createdAt: z.string().datetime(),
});
export const ScheduleMeetingRequestSchema = z.object({
    title: z.string().min(1).max(200),
    startTime: z.string().datetime(),
    endTime: z.string().datetime(),
    platform: z.enum(Object.values(MeetingPlatform)),
    attendeeEmails: z.array(z.string().email()).max(50),
    description: z.string().max(5000).optional(),
    location: z.string().max(500).optional(),
    clientId: z.string().uuid().optional(),
    dealId: z.string().uuid().optional(),
});
export const ScheduleMeetingResponseSchema = z.object({
    meetingId: z.string().uuid(),
    calendarEventId: z.string().uuid(),
    meetingLink: z.string().url(),
    htmlLink: z.string().url().nullable(),
});
